"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var useCiselnik_1 = __importDefault(require("../../../hooks/useCiselnik"));
var LinkButton_1 = __importDefault(require("../../Button/LinkButton"));
var components_1 = require("../components");
var Label_1 = __importDefault(require("../components/Label"));
var RemovableDropdown_1 = __importDefault(require("../inputs/RemovableDropdown"));
var Pridat = styled_components_1.default(LinkButton_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 15px;\n  line-height: 22px;\n  text-decoration-line: underline;\n  color: #2362a2;\n  margin-top: 1em;\n"], ["\n  font-size: 15px;\n  line-height: 22px;\n  text-decoration-line: underline;\n  color: #2362a2;\n  margin-top: 1em;\n"])));
var TypyDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: grid;\n  row-gap: 1em;\n"], ["\n  display: grid;\n  row-gap: 1em;\n"])));
var filterAvailable = function (selectedIds) { return ramda_1.filter(function (typ) { return !ramda_1.includes(typ.id, selectedIds); }); };
var mapToOptions = ramda_1.map(function (typ) { return ({ value: typ.id, label: typ.nazev }); });
var TypyPrestupkuField = function (_a) {
    var name = _a.name, label = _a.label;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    var _c = useCiselnik_1.default('typyPrestupku'), loading = _c.loading, error = _c.error, data = _c.data;
    var value = field.value || [];
    if (loading) {
        return react_1.default.createElement(react_1.default.Fragment, null, "na\u010D\u00EDt\u00E1n\u00ED");
    }
    if (error) {
        return react_1.default.createElement(react_1.default.Fragment, null, error);
    }
    var handleChange = function (index, idTypu) {
        var typ = data === null || data === void 0 ? void 0 : data.find(function (t) { return t.id === idTypu; });
        if (typ)
            helpers.setValue(ramda_1.set(ramda_1.lensIndex(index), typ, value));
    };
    var handleAdd = function () {
        helpers.setValue(ramda_1.append({}, value));
    };
    var handleRemove = function (index) { return function () {
        helpers.setValue(ramda_1.remove(index, 1, value));
    }; };
    if (value.length === 0)
        handleAdd();
    return (react_1.default.createElement(components_1.Field, { topAlign: true },
        react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement("fieldset", { name: name },
            react_1.default.createElement(TypyDiv, null, ramda_1.addIndex(ramda_1.map)(function (typ, index) {
                var usedIds = ramda_1.without([typ.id], ramda_1.pluck('id', field.value));
                var options = ramda_1.pipe(filterAvailable(usedIds), mapToOptions)(data || []);
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement(RemovableDropdown_1.default, { hasError: !!meta.error, placeholder: "Vyberte ze seznamu", name: "typPrestupku-" + typ.id, value: typ.id, onChange: function (v) { return handleChange(index, v); }, onRemove: handleRemove(index), loadOptions: function () { return Promise.resolve(options); }, showRemove: index !== 0, rightAlign: false, key: typ.id || "create-" + index })));
            }, value)),
            react_1.default.createElement(Pridat, { type: "button", onClick: handleAdd, name: "PridatPrestupek" }, "+ P\u0159idat dal\u0161\u00ED"))));
};
exports.default = TypyPrestupkuField;
var templateObject_1, templateObject_2;
